/**
 * Guest.Gallery's official Instagram and Facebook profiles (the same accounts
 * the team posts from). The footer uses the Danish accounts for da and the
 * English accounts as the fallback for every other locale.
 * All four go into the Organization `sameAs`. Checked to resolve on 26 Oct 2026.
 */
export const SOCIAL_PROFILES = {
  da: {
    instagram: "https://www.instagram.com/guest_dot_gallery/",
    facebook: "https://www.facebook.com/people/GuestGallery/61559610476949/",
  },
  en: {
    instagram: "https://www.instagram.com/guest.dot.gallery/",
    facebook:
      "https://www.facebook.com/people/GuestGallery-US/61576776880340/",
  },
} as const;

export const SOCIAL_PROFILE_URLS: string[] = [
  ...Object.values(SOCIAL_PROFILES.da),
  ...Object.values(SOCIAL_PROFILES.en),
];

export function getSocialProfiles(
  locale: string,
): (typeof SOCIAL_PROFILES)["da" | "en"] {
  return locale === "da" ? SOCIAL_PROFILES.da : SOCIAL_PROFILES.en;
}
